import React, {PureComponent} from 'react';
import ProfileRadiobox from './profile-radiobox';

export default class TypeProfile extends PureComponent{
	render(){
		const {profiledata, currentProfileId, onChangeTypeProfile} = this.props;
		const elements = profiledata.map( (item, i) => {
			// передаем всё кроме id
			return (
				<React.Fragment key={item.id}>
					<ProfileRadiobox
						currentProfileId = {currentProfileId}
						onChangeTypeProfile = {onChangeTypeProfile}
						id = {item.id}
						label={item.label}
					/>
				</React.Fragment>
			)
		});

		return (
			<div className="wincalc-profile">
				<div className="wincalc-title">тип профиля</div>
				<div className="wincalc-box">
					{elements}
				</div>
			</div>
		)
	}
}
